'use client';

import React from 'react';
import dynamic from 'next/dynamic';

import { Typography } from 'lighthouse';

import { LocationsMapProps } from '@/widgets/LocationsMap/models';

import { InfoTabSkeleton } from './components/InfoTabSkeleton';
import { InfoTabProps } from './models';

import { Location, Routing } from 'iconsax-react';

const VendorLocationsMap = dynamic<LocationsMapProps>(() => import('@/widgets/LocationsMap').then((mod) => mod.LocationsMap), {
    ssr: false,
    loading: () => <div className='h-full w-full animate-pulse bg-N100' />
});

export const InfoTab = ({ vendor }: InfoTabProps) => {
    if (!vendor) {
        return (
            <div className='p-3 sm:p-4'>
                <InfoTabSkeleton />
            </div>
        );
    }

    const hasVendorRate = typeof vendor.rate === 'number' && !Number.isNaN(vendor.rate) && vendor.ratesNumber > 0;
    const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${vendor.latitude},${vendor.longitude}`;
    const address = [vendor.cityName?.trim(), vendor.address].filter(Boolean).join('، ');

    return (
        <div className='flex flex-col gap-3 p-3 sm:gap-4 sm:p-4'>
            <section className='overflow-hidden rounded-lg border border-solid border-N200'>
                <div
                    className='flex flex-col gap-2.5 border-b border-solid border-N100 p-3 sm:flex-row sm:items-center sm:justify-between sm:gap-3
                        sm:p-4'>
                    <div className='flex min-w-0 items-start gap-2.5'>
                        <div className='flex size-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary sm:size-10'>
                            <Location size={17} variant='Bold' color='currentcolor' aria-hidden />
                        </div>
                        <div className='min-w-0'>
                            <Typography className='!m-0 text-sm font-bold leading-5 text-blackHighEmphasis'>موقعیت و آدرس</Typography>
                            <Typography className='!m-0 mt-0.5 text-xs leading-5 text-blackMediumEmphasis sm:text-sm sm:leading-6'>
                                {address}
                            </Typography>
                        </div>
                    </div>

                    <a
                        href={directionsUrl}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='inline-flex h-9 shrink-0 cursor-pointer items-center justify-center gap-1.5 self-stretch rounded-lg bg-primary
                            px-3.5 text-sm font-medium text-white transition-colors duration-200 hover:bg-secondary focus-visible:outline
                            focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary sm:h-10 sm:self-center sm:px-4'>
                        <Routing size={16} color='currentcolor' aria-hidden />
                        مسیریابی
                    </a>
                </div>

                <div className='h-44 w-full sm:h-52 md:h-60'>
                    <VendorLocationsMap
                        locations={[
                            {
                                id: vendor.uuid,
                                lat: vendor.latitude,
                                lng: vendor.longitude,
                                title: vendor.name,
                                address,
                                rate: hasVendorRate ? vendor.rate : null,
                                ratesNumber: hasVendorRate ? vendor.ratesNumber : null
                            }
                        ]}
                        activeLocationId={vendor.uuid}
                        initialZoom={15}
                        className='!h-full !rounded-none !border-0 !shadow-none'
                        defaultLocation={[vendor.latitude, vendor.longitude]}
                    />
                </div>
            </section>
        </div>
    );
};
